import React from "react";

const AppML_Case_Suppliers = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Case Suppliers</h1>
      <p>This is the AppML Case Suppliers page content.</p>
    </div>
  );
};

export default AppML_Case_Suppliers;
